import PropTypes from 'prop-types';
import React from 'react';
import Tile from './ui/Tile';
import * as NextStepUtils from '../utilities/next-steps';
import { getUID } from '../utilities/storage';

class NextSteps extends React.Component {
	constructor(props) {
		super(props);

		this.getRecommendedContent = NextStepUtils.getRecommendedContent.bind(this);
	}

	componentDidMount = () => {
		const { dimensions, userData } = this.props;

		/**
		 * Handle HubSpot form data
		 */

		const wrapper = document.querySelector('.maturity-score');

		const hiddenFormMeta = {
			uid: 'input[name="itdms_uid"]',
			score: 'input[name="itdms_score"]',
			dimension: 'input[name="itdms_dimension"]',
		};

		if (getUID() && wrapper.querySelector(hiddenFormMeta.uid)) {
			wrapper.querySelector(hiddenFormMeta.uid).value = getUID();
		}

		if ('score' in userData && wrapper.querySelector(hiddenFormMeta.score)) {
			wrapper.querySelector(hiddenFormMeta.score).value = userData.score;
		}

		if (wrapper.querySelector(hiddenFormMeta.dimension)) {
			const dimensionScores = [];
			Object.keys(userData.dimensions).map((key) => {
				if (dimensions[key].include_in_score) {
					dimensionScores.push(`${dimensions[key].name}: ${userData.dimensions[key].score}`);
				}
			});

			wrapper.querySelector(hiddenFormMeta.dimension).value = dimensionScores.join('\n');
		}
	};

	render() {
		const { headline, subline, custom_content } = this.props;
		const recommendations = this.getRecommendedContent();

		return (
			<div className="ms-form__next">
				<h2>{headline}</h2>
				{subline && <p>{subline}</p>}
				{recommendations && (
					<div className="tile-grid" data-row-elms="4">
						{Object.keys(recommendations).map((key) => {
							const rec = recommendations[key];
							const tile_content = {
								name: rec.title,
								desc: rec.link_text,
								link_type: rec.link_type,
								link: rec.link,
								image: rec.image,
							};
							return <Tile key={key} tile_content={tile_content} />;
						})}
					</div>
				)}
				<div className="ms-form__custom-content" dangerouslySetInnerHTML={{ __html: custom_content }}></div>
			</div>
		);
	}
}

export default NextSteps;

NextSteps.propTypes = {
	custom_content: PropTypes.string,
	dimensions: PropTypes.object,
	headline: PropTypes.string,
	slides: PropTypes.any,
	subline: PropTypes.string,
	userData: PropTypes.object,
};
